import { ISection } from './types';
import QuestionFactory from './QuestionFactory';

export default class SectionFactory {
  static Create(): ISection {
    return {
      heading: '',
      questions: [QuestionFactory.Create()],
    };
  }
}
